import '@mdi/font/css/materialdesignicons.css'
import '@/stylesheets/Fonts.scss'

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from "@/store";
import {LocaleApi} from "@swagger";
import VueI18n from "vue-i18n";
import Vuetify from "vuetify";
import VueCookie from "vue-cookie";
import {VueMasonryPlugin} from "vue-masonry";
import BasicComponent, {getApiUrl} from "@/global/BasicComponent";

Vue.config.productionTip = false;

Vue.use(Vuetify);



Vue.use(VueCookie);
Vue.use(VueI18n);
Vue.use(VueMasonryPlugin);
Vue.mixin(BasicComponent);

new LocaleApi({
    basePath: getApiUrl(),
}).getMessages()
    .then((data: any) => {
        const defaultLanguage = data.defaultLanguage ?? "de"
        const activeLanguages = data.activeLanguages ?? [{code: defaultLanguage, displayName: "Deutsch", flag: "at"}]
        const perLanguageMessages = data.messages ?? {}
        const settings = data.settings ?? {}

        const defaultMessages = perLanguageMessages[defaultLanguage] ?? {}
        document.title = defaultMessages["PAGE_TITLE"] ?? "Fotobestellung"
        document.documentElement.lang = defaultLanguage

        const i18nMessages: Record<string, any> = {}
        for (const lang of activeLanguages) {
            const langMessages = perLanguageMessages[lang.code] ?? {}
            i18nMessages[lang.code] = {...langMessages, ...settings}
        }

        const savedLocale = localStorage.getItem('locale')
        const initialLocale = savedLocale && i18nMessages[savedLocale] ? savedLocale : defaultLanguage

        const i18n = new VueI18n({
            locale: initialLocale,
            fallbackLocale: defaultLanguage,
            messages: i18nMessages,
            silentFallbackWarn: true,
        });

        document.documentElement.lang = initialLocale

        store.commit('setActiveLanguages', activeLanguages)

        const vuetify = new Vuetify({
            theme: {
                options: {
                    customProperties: true
                },
                themes: {
                    light: {
                        primary: settings["COLOR_PRIMARY"],
                        secondary: settings["COLOR_SECONDARY"],
                        accent: settings["COLOR_ACCENT"],
                        error: '#FF5252',
                        info: '#2196F3',
                        success: '#4CAF50',
                        warning: '#FFC107'
                    }
                }
            }
        });

        var vm = new Vue({
            vuetify,
            router,
            store,
            i18n,
            render: h => h(App)
        }).$mount('#app');

    })
    .catch((err) => {
        if (err.json) err.json().then(error => {
            console.error(error)
        });
        else console.error(err);
    });



